/**
 * PressCalendariumBlock
 * @module components/PressCalendariumBlock
 */
import PropTypes from 'prop-types';
import { Grid, Cell } from 'components/ui/Grid';
import Button from 'components/ui/Button';
import PressReleaseItem from './PressReleaseItem.js';
import CalendarItem from './CalendarItem.js';
import Layout from 'components/ui/Layout/Layout';
import Icon from 'components/ui/Icon';
import { useSiteType } from 'context/siteType.context';
import clsx from 'clsx';

const PressCalendariumBlock = ({
	latestPressReleasesText,
	calendarText,
	pressReleases,
	calendarEvents,
	allPressReleasesText,
	allPressReleasesLink,
	allCalendarEventsText,
	allCalendarEventsLink,
}) => {
	const siteType = useSiteType();
	return (
		<Layout>
			<Grid>
				<Cell span={12} tablet={6}>
					<h2
						className={clsx(
							'font-heading md:text-h2 md:my-4 text-h4 my-1',
							siteType === 'LindabGroup'
								? 'text-lgDarkBlue font-medium'
								: 'text-blue font-bold'
						)}
					>
						{latestPressReleasesText}
					</h2>
					{pressReleases.map((release, i) => {
						return <PressReleaseItem {...release} key={i} />;
					})}
					<Button
						type="link"
						url={allPressReleasesLink}
						buttonColor={siteType === 'LindabGroup' ? 'lgYellow' : 'blue'}
					>
						{allPressReleasesText}
						<Icon
							icon={siteType === 'LindabGroup' ? 'chevrons' : 'arrow'}
							direction={siteType === 'LindabGroup' ? 'left' : 'right'}
							size={1.25}
						/>
					</Button>
				</Cell>
				<Cell span={12} tablet={6}>
					<h2
						className={clsx(
							'font-heading md:text-h2 md:my-4 text-h4 my-1',
							siteType === 'LindabGroup'
								? 'text-lgDarkBlue font-medium'
								: 'text-blue font-bold'
						)}
					>
						{calendarText}
					</h2>
					{calendarEvents.map((calendarEvent, i) => {
						return <CalendarItem {...calendarEvent} key={i} />;
					})}
					<Button
						type="link"
						url={allCalendarEventsLink}
						buttonColor={siteType === 'LindabGroup' ? 'lgYellow' : 'blue'}
					>
						{allCalendarEventsText}
						<Icon
							icon={siteType === 'LindabGroup' ? 'chevrons' : 'arrow'}
							direction={siteType === 'LindabGroup' ? 'left' : 'right'}
							size={1.25}
						/>
					</Button>
				</Cell>
			</Grid>
		</Layout>
	);
};

PressCalendariumBlock.propTypes = {
	block: PropTypes.shape({
		latestPressReleasesText: PropTypes.string,
		calendarText: PropTypes.string,
		pressReleases: PropTypes.arrayOf(
			PropTypes.shape({
				date: PropTypes.string,
				name: PropTypes.string,
				link: PropTypes.string,
			})
		),
		calendarEvents: PropTypes.arrayOf(
			PropTypes.shape({
				date: PropTypes.string,
				name: PropTypes.string,
				month: PropTypes.string,
				day: PropTypes.string,
				addToCalendarStartDate: PropTypes.string,
				addToCalendarEndDate: PropTypes.string,
				addToCalendarLocation: PropTypes.string,
				link: PropTypes.string,
			})
		),
		allPressReleasesText: PropTypes.string,
		allPressReleasesLink: PropTypes.string,
		allCalendarEventsText: PropTypes.string,
		allCalendarEventsLink: PropTypes.string,
	}),
};

export default PressCalendariumBlock;
